import Dialog from './dialog.vue';
import More from './more.vue';
export default {
  components: {
    Dialog,
    More
  },
  props: {
    showMore: {
      default: false,
      type: Boolean
    },
    masterTeacher: {},
    zhsCourseUrl: {},
    courseUrl: {},
    classStatus: {},
    trainAddress: {},
    teachType: {},
    classType: {},
    termId: {},
    loginId: {},
    price: {},
    showAction: {
      default: true,
      type: Boolean
    },
    showTerm: {
      default: false
    },
    termName: {},
    startTime: {},
    endTime: {},
    trainingId: {},
    recruitId: {},
    abbr: {
      default: false,
      type: Boolean
    },
    showType: {
      default: false,
      type: Boolean
    },
    showWay: {
      default: false,
      type: Boolean
    },
    showClassTime: {
      default: false,
      type: Boolean
    },
    showMaster: {
      default: false,
      type: Boolean
    },
    showLine: {
      default: false,
      type: Boolean
    },
    imgSrc: {
      default: 'https://cus-kcsz1.oss-cn-hangzhou.aliyuncs.com/shiepedu/67375427eabf452490c2ac176522b8a4.jpg'
    },
    imgAlt: {
      default: '照片正在加载中'
    },
    trainTitle: {},
    trainDescribe: '',
    status: {}
  },

  data() {
    return {
      isShowSeeMoreDialog: false,
      STATUS: {
        CANCEL: 0,
        LEARN: 1,
        DETAIL: 2,
        PAY: 3,
        REAPPLY: 4,
        CLASSLEARN: 5,
        LOOK: 6
      },
      rejectInfo: '',
      addressInfo: '',
      actionName: this.getActionName(),
      _status: this.statusFun(),
      defaultImg: require('@/assets/images/common/course_cover.png')
    };
  },

  computed: {
    coverImg() {
      if (this.$props.imgSrc === null) {
        return this.$props.imgSrc = this.defaultImg;
      } else {
        return this.$props.imgSrc;
      }
    }

  },
  methods: {
    showMoreClick() {
      this.isShowSeeMoreDialog = !this.isShowSeeMoreDialog;
    },

    statusFun() {
      switch (this.$props.status) {
        case 0:
          return this._status = '报名取消';

        case 1:
          return this._status = '';

        case 2:
          return this._status = '已报名待审核';

        case 3:
          return this._status = `￥${this.$props.price}`;

        case 4:
          return this._status = '报名被驳回>';

        case 5:
          return this._status = '';

        case 6:
          return this._status = '';

        default:
          return this._status = '待确认';
      }
    },

    getActionName() {
      switch (this.$props.status) {
        case 0:
          return this.actionName = '查看报名信息';

        case 1:
          return this.actionName = '去学习';

        case 2:
          return this.actionName = '查看报名信息';

        case 3:
          return this.actionName = '去付款';

        case 4:
          return this.actionName = '重新报名';

        case 5:
          return this.actionName = '去学习';

        case 6:
          return this.actionName = '去查看';

        default:
          return this.actionName = '待确认';
      }
    },

    async getRejectInfo() {
      return await this.$http.getRejectInfo({
        recruitId: this.$props.recruitId
      }).then(res => {
        if (!res) {
          console.error('getRejectInfo:no data');
          this.rejectInfo = {};
        } else {
          this.rejectInfo = res;
        }
      });
    },

    refusedClick(e) {
      if (e === '报名被驳回>') {
        this.getRejectInfo();
        this.$refs.child.open();
      }
    },

    async actionClick(r, t) {
      switch (this.$props.status) {
        case this.STATUS.CANCEL:
          window.location.href = `/trainDetail.html?recruitId=${r}&trainingId=${t}`;
          break;

        case this.STATUS.LEARN:
          window.location.href = `/trainDetail.html?recruitId=${r}&trainingId=${t}`;
          break;

        case this.STATUS.DETAIL:
          window.location.href = `/trainDetail.html?recruitId=${r}&trainingId=${t}`;
          break;

        case this.STATUS.PAY:
          window.location.href = `/trainDetail.html?recruitId=${r}&trainingId=${t}`;
          break;

        case this.STATUS.REAPPLY:
          window.location.href = `/trainDetail.html?recruitId=${r}&trainingId=${t}`;
          break;

        case this.STATUS.CLASSLEARN:
          if (parseInt(this.$props.classStatus) === 1) {
            window.open(this.$props.zhsCourseUrl);
          }

          if (parseInt(this.$props.classStatus) === 2) {
            window.open(this.$props.courseUrl);
          }

          break;

        case this.STATUS.LOOK:
          window.open(this.$props.courseUrl);

        default:
          console.error('学习状态不对');
          break;
      }
    }

  }
};